'use strict';

import { getUrlParam } from '../../functions';

export class BmbyMode {
  static active = getUrlParam('mode') === 'bmby';
}
